import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IsCBMManagment, loginCompanyID, loginPartyID, loginUserIsFranchisesRole } from "../../../components/Common/CommonFunction";
import { PosDashboard_Report_Action } from "../../../store/Report/POSDashBoardDetailsRedux/action";
import PosDashboardTable from "../../../Reports/POSDashBoard Details/PosDashboardTable ";
import { getCommonPartyDrodownOptionAction } from "../../../store/Utilites/PartyDrodown/action";

const PosExeVersionDetails = () => {

    const dispatch = useDispatch();
    const isFranchise = loginUserIsFranchisesRole();
    const IsMannagementParty = IsCBMManagment();
    const { tableData, Distributor, selectedParty } = useSelector((state) => ({
        tableData: state.PosDashboardReducer.PosDashboard_Gobtn,
        Distributor: state.CommonPartyDropdownReducer.commonPartyDropdownOption,
        selectedParty: state.CommonPartyDropdownReducer.commonPartyDropSelect,
    })); 

    // Same as POSDashBoard.js's visibleData — the full, unfiltered dataset.
    // The old HasSyncIssue pre-filter is dropped so the Running OK / All
    // Machines cards (and every other tab) reflect every machine, not just
    // the ones already known to have an issue.
    const rows = tableData?.Data || [];

    // Separate service-heartbeat feed the "Service Not Working" sub-tab
    // reads from — same source POSDashBoard.js uses (tableData.ServiceRows).
    const serviceRows = tableData?.ServiceRows || [];

    const partyNameMap = useMemo(() => {
        const map = {};
        (Distributor || []).forEach(p => {
            map[p.id] = p.Name;
        });
        return map;
    }, [Distributor]);

    // NEW — load the party dropdown data so partyNameMap can resolve names
    useEffect(() => {
        if (!Distributor || Distributor.length === 0) {
            dispatch(getCommonPartyDrodownOptionAction());
        }
    }, [dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        let party;
        if (isFranchise) {
            party = loginPartyID();
        } else {
            party = selectedParty.value ?? 0;
        }
        dispatch(
            PosDashboard_Report_Action({
                jsonBody: JSON.stringify({ Party: party, CompanyID: loginCompanyID() }),
                btnId: "Print"
            })
        );
    }, [dispatch, selectedParty, isFranchise]);

    const tableColumns = [
        { text: "Client ID", dataField: "ClientID" },
        { text: "Party", dataField: "Party" },
        { text: "Invoice Created On", dataField: "MaxInvoiceCreatedOn" },
        { text: "Deleted Invoice Created On", dataField: "MaxDeletedInvoiceCreatedOn" },
        { text: "Sync Status", dataField: "VersionMismatchList" },
        { text: "Versions", dataField: "Versions" },
        { text: "POS Log Pushed At", dataField: "CreatedOnList" },
    ];

    return (
        <PosDashboardTable
            rows={rows}
            serviceRows={serviceRows}
            tableColumns={tableColumns}
            IsMannagementParty={IsMannagementParty}
            partyNameMap={partyNameMap}
            isFranchise={isFranchise}
        />
    );
};

export default PosExeVersionDetails;